export default __webpack_public_path__ + "935011d646d19924662e08fb606f734f.svg";